// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__39JEP","col":"styles_col__2q955","fulfillmentStatus":"styles_fulfillmentStatus__2-8_k","emailCol":"styles_emailCol__14mDr"};